var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberFive = function SvgIconNumberFive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.985 2.84A1 1 0 0 1 8.972 2H16.5a1 1 0 0 1 0 2H9.822L8.85 9.967a6.286 6.286 0 0 1 8.17 3.388 6.23 6.23 0 0 1-1.362 6.817 6.287 6.287 0 0 1-8.863 0 1 1 0 1 1 1.41-1.419 4.287 4.287 0 0 0 6.043 0 4.23 4.23 0 0 0 0-6.006 4.29 4.29 0 0 0-6.043 0 1 1 0 0 1-1.692-.87z"
  })));
};
export default SvgIconNumberFive;